import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
// Legacy global styles (shared by the admin / staff / resource-person areas):
// imported once here so components can use plain Tailwind classes instead of
// importing this stylesheet themselves.
import "./styles/navbar.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CartProvider } from "./components/CardContext";
import {ConfirmDialogProvider} from "./components/ConfirmDialogProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CartProvider>
      <ConfirmDialogProvider>
        <App />
      </ConfirmDialogProvider>
    </CartProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
